import { useState, useEffect } from "react";
import {
  OpenFeatureProvider,
  useBooleanFlagValue,
  OpenFeature,
} from "@openfeature/react-sdk";
import DevCycleProvider from "@devcycle/openfeature-web-provider";
import Config from "./env";

export const FEATURE_FLAGS = {
  LSP: "lsp",
  ENTITY_CALENDAR: "entity-calendar",
  DOCUMENT_STORAGE: "document-storage",
  MESSAGING: "messaging",
  NOTIFICATIONS: "notifications",
  USER_SPECIFIC_FEATURE: "user-specific-feature",
  REQUESTS: "requests",
  ESCALATIONS: "escalations",
  UPDATE_ACTIVE_SERVICES: "update-active-services",
  MY_CALENDAR: "my-calendar",
  MY_DASHBOARD: "my-dashboard",
  EMPLOYEE_REGISTRY: "employee-registree",
  PAYSLIP_UPLOAD: "payslip-upload",
  IMPLEMENTATION_REQUEST: "implementation-adhoc-type",
};

export const initializeFeatureFlags = async (userContext) => {
  if (!userContext?.user_id && !userContext?.targetingKey) {
    console.error(
      "[Feature Flags] Initialization failed: userContext must contain user_id or targetingKey.",
      userContext,
    );
    return false;
  }

  try {
    await OpenFeature.setContext(userContext);
    console.log("[Feature Flags] Setting initial context:", userContext);

    await OpenFeature.setProviderAndWait(
      new DevCycleProvider(Config.DEV_CYCLE_SDK_KEY),
    );
    console.info(
      "[Feature Flags] Provider initialized successfully with user context.",
    );
    return true;
  } catch (error) {
    console.error("[Feature Flags] Failed to initialize provider:", error);
    return false;
  }
};

export const useFeatureFlag = (flagName, defaultValue = false) => {
  const [isLoading, setIsLoading] = useState(true);
  const value = useBooleanFlagValue(flagName, defaultValue);

  useEffect(() => {
    if (value !== undefined) {
      setIsLoading(false);
    }
  }, [value]);

  return {
    value: value ?? defaultValue,
    isLoading,
  };
};

export { OpenFeatureProvider, OpenFeature };
